module.exports = __webpack_public_path__ + "img/framenew_box05.5e5e5c5f.jpg";